/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  SUCCESS_SAVE_ASSET,
  FAILURE_SAVE_ASSET,
  ASSET_DETAIL_SUCCESS,
  ASSET_DETAIL_FAILURE,
  LOOKUP_ASSET,
  LOOKUP_ASSET_SUCCESS,
  LOOKUP_ASSET_FAILURE,
  BULK_ADD_ASSET,
  BULK_ADD_ASSET_SUCCESS,
  BULK_ADD_ASSET_FAILURE,
  LOOKUP_PARCEL,
  LOOKUP_PARCEL_SUCCESS,
  LOOKUP_PARCEL_FAILURE,
  RESET_ADD_ASSET,
  ADD_ASSET_AND_FINANCIALS,
  ADD_ASSET_AND_FINANCIALS_SUCCESS,
  ADD_ASSET_AND_FINANCIALS_FAILURE,
} from "../actions/asset/assetActionTypes";

import {
  setLoadingState,
  setSuccessResponse,
  setErrorResponse,
} from "./reducerUtils";

const initialState = {
  bulkAddAsset: {
    data: [],
    state: "INIT",
    error: null,
  },
  parcelLookup: {
    data: [],
    state: "INIT",
    error: null,
  },
  assetLookup: {
    data: [],
    state: "INIT",
    error: null,
  },
  addAssetAndFinancials: {
    data: [],
    state: "INIT",
    error: null,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SUCCESS_SAVE_ASSET:
      return {
        // ...state,
        // saving: false,
        // success: true,
        isSavingAssetSuccess: true,
        slug: action.payload.data.slug,
      };
    case FAILURE_SAVE_ASSET:
      return {
        // ...state,
        // saving: false,
        // success: false,
        isSavingAssetSuccess: false,
        error: action.err.message,
      };
    case ASSET_DETAIL_SUCCESS:
      return {
        // loading: false,
        assetDetailSuccess: true,
        data: action.payload.data,
      };
    case ASSET_DETAIL_FAILURE:
      return {
        // loading: false,
        assetDetailSuccess: false,
        error: action.err.message,
      };
    case LOOKUP_ASSET:
      return setLoadingState(state, "assetLookup");

    case LOOKUP_ASSET_SUCCESS:
      return setSuccessResponse(state, action, "assetLookup");

    case LOOKUP_ASSET_FAILURE:
      return setErrorResponse(state, action.err, "assetLookup");

    case BULK_ADD_ASSET:
      return setLoadingState(state, "bulkAddAsset");

    case BULK_ADD_ASSET_SUCCESS:
      return setSuccessResponse(state, action, "bulkAddAsset");

    case BULK_ADD_ASSET_FAILURE:
      return setErrorResponse(state, action.errResp, "bulkAddAsset");

    case LOOKUP_PARCEL:
      return setLoadingState(state, "parcelLookup");

    case LOOKUP_PARCEL_SUCCESS:
      return setSuccessResponse(state, action, "parcelLookup");

    case LOOKUP_PARCEL_FAILURE:
      return setErrorResponse(state, action.errResp, "parcelLookup");

    case RESET_ADD_ASSET:
      return setLoadingState(state, "addAssetAndFinancials");
    case ADD_ASSET_AND_FINANCIALS:
      return setLoadingState(state, "addAssetAndFinancials");
    case ADD_ASSET_AND_FINANCIALS_SUCCESS:
      return setSuccessResponse(state, action, "addAssetAndFinancials");
    case ADD_ASSET_AND_FINANCIALS_FAILURE:
      return setErrorResponse(state, action.errResp, "addAssetAndFinancials");

    default:
      return state;
  }
}
